import React, { PropsWithChildren, ReactElement, FC } from 'react';

import './MiniBadge.css';

type MiniBadgeProps = PropsWithChildren<{ variant?: string }>;
const MiniBadge: FC<MiniBadgeProps> = ({
	variant = 'info',
	children,
}: MiniBadgeProps): ReactElement => {
	return <span className={`status-mini ${variant && 'status-' + variant}`}>{children}</span>;
};
export default MiniBadge;
